if (process.env.REACT_APP_ENVIRONMENT === 'local') {
    module.exports = require('./settings-local.json');
} else if (process.env.REACT_APP_ENVIRONMENT === 'uat') {
    module.exports = require('./settings-uat.json');
} else if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    module.exports = require('./settings-prod.json');
} else if (process.env.REACT_APP_ENVIRONMENT === 'development') {
    if (process.env.REACT_APP_TEST_EVIROMENT === 'test2')
        module.exports = require('./settings-dev2.json');
    else module.exports = require('./settings-dev.json');
} else module.exports = require('./settings-dev.json');
